import React from 'react';

import PlayerBallFlightList from './PlayerBallFlightList';
import { fixDecimals } from '../../../helpers';
import { PeriodsPropsType } from './types';
import { useTablePropertiesState } from '../../../store/hooks';
import { useRouter } from '../../../helpers/customHooks';

const Periods = ({ sessionList }: PeriodsPropsType) => {
  
  const { specificScope } = useRouter();
  const { orderColumn: orderingBy = 0 } = useTablePropertiesState(specificScope);
  
  const period: JSX.Element[] = [];
  let index = 0;
  if (sessionList) {
    sessionList.sort((first, second) => {
      switch (Math.abs(orderingBy)) {
        case 2:
          return orderingBy === 2 ? first.total - second.total : second.total - first.total;
        case 3:
          return orderingBy === 3 ? first.avgInitAirSpeedInMph - second.avgInitAirSpeedInMph :
            second.avgInitAirSpeedInMph - first.avgInitAirSpeedInMph;
        case 4:
          return orderingBy === 4 ? first.avgInitRotation - second.avgInitRotation :
            second.avgInitRotation - first.avgInitRotation;
        case 5:
          return orderingBy === 5 ? first.avgFlightDurInSec - second.avgFlightDurInSec :
            second.avgFlightDurInSec - first.avgFlightDurInSec;
        case 6:
          return orderingBy === 6 ? first.avgPeakHeightInFeet - second.avgPeakHeightInFeet :
            second.avgPeakHeightInFeet - first.avgPeakHeightInFeet;
        case 7:
          return orderingBy === 7 ? first.avgGroundDistInYards - second.avgGroundDistInYards :
            second.avgGroundDistInYards - first.avgGroundDistInYards;
        default:
          return 0;
      }
    }).forEach(session => {
      index++;
      period.push(
        <div key={index}>
          <PlayerBallFlightList
            sessionName={session.sessionName}
            playerBallFlightList={session.ballFlightModelList}
          />
          <div className="summary-00">
            <div style={{ width: '100px', padding: '34px 32px' }}>
              <label style={{ fontSize: '13px', fontWeight: 'bold' }}>SUMMARY</label>
            </div>
            <div style={{ padding: '10px 0px' }}>
              <div className="summary-body">
                <div style={{ width: '90px', padding: '0px 15px' }}>
                  <p>TOTAL</p>
                  <label>{session.total}</label>
                </div>
                <div style={{ width: '75px', padding: '0px 15px' }}>
                  <p>AVERAGE</p>
                  <label>{fixDecimals(session.avgInitAirSpeedInMph, 1)}</label>
                </div>
                <div style={{ width: '80px', padding: '0px 15px' }}>
                  <p>AVERAGE</p>
                  <label>{fixDecimals(session.avgInitRotation, 0)}</label>
                </div>
                <div style={{ width: '95px', padding: '0px 15px' }}>
                  <p>AVERAGE</p>
                  <label>{fixDecimals(session.avgFlightDurInSec, 2)}</label>
                </div>
                <div style={{ width: '75px', padding: '0px 15px' }}>
                  <p>AVERAGE</p>
                  <label>{fixDecimals(session.avgPeakHeightInFeet, 1)}</label>
                </div>
                <div style={{ width: '75px', padding: '0px 15px' }}>
                  <p>AVERAGE</p>
                  <label>{fixDecimals(session.avgGroundDistInYards, 1)}</label>
                </div>
              </div>
              <div className="summary-body">
                <div style={{ width: '165px', padding: '0px 15px' }}>
                  <p>MAX</p>
                  <label>{fixDecimals(session.maxAirSpeedInMph, 1)}</label>
                </div>
                <div style={{ width: '80px', padding: '0px 15px' }}>
                  <p>MAX</p>
                  <label>{fixDecimals(session.maxInitRotation, 0)}</label>
                </div>
                <div style={{ width: '95px', padding: '0px 15px' }}>
                  <p>MAX</p>
                  <label>{fixDecimals(session.maxFlightDurInSec, 2)}</label>
                </div>
                <div style={{ width: '75px', padding: '0px 15px' }}>
                  <p>MAX</p>
                  <label>{fixDecimals(session.maxPeakHeightInFeet, 1)}</label>
                </div>
                <div style={{ width: '75px', padding: '0px 15px' }}>
                  <p>MAX</p>
                  <label>{fixDecimals(session.maxGroundDistInYards, 1)}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }
  return <div>{period}</div>;
};

export default Periods;
